(function() {
  'use strict';

  function initRyzeAnnouncementBar() {
    const bars = document.querySelectorAll('.ryze-announcement-bar');
    
    bars.forEach(function(bar) {
      const timerMode = bar.getAttribute('data-timer-mode') || 'cycling';
      const cycleDurationHours = parseFloat(bar.getAttribute('data-cycle-hours')) || 12;
      const cycleDurationMs = cycleDurationHours * 60 * 60 * 1000;
      const endDate = bar.getAttribute('data-end-date') || '';
      const endTime = bar.getAttribute('data-end-time') || '23:59';
      const hideDays = bar.getAttribute('data-hide-days') === 'true';

      const daysEl = bar.querySelector('[data-days]');
      const hoursEl = bar.querySelector('[data-hours]');
      const minutesEl = bar.querySelector('[data-minutes]');
      const secondsEl = bar.querySelector('[data-seconds]');
      
      if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;
      
      // Calculate the end date timestamp for end_date mode
      let endTimestamp = null;
      if (timerMode === 'end_date' && endDate) {
        const dateTimeString = endDate + 'T' + endTime + ':00';
        endTimestamp = new Date(dateTimeString).getTime();
      }
      
      function getTimeRemaining() {
        const now = Date.now();
        
        if (timerMode === 'end_date' && endTimestamp) {
          // End date mode: count down to specific date/time
          const remaining = endTimestamp - now;
          return Math.max(0, remaining);
        } else {
          // Cycling mode: calculate position within the current cycle
          const elapsed = now % cycleDurationMs;
          return cycleDurationMs - elapsed;
        }
      }
      
      function updateCountdown() {
        const timeRemaining = getTimeRemaining();
        
        let days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
        let hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

        // When the days unit is hidden the hours have to absorb it, or a
        // countdown more than a day out would read short.
        if (hideDays) {
          hours += days * 24;
          days = 0;
        }

        daysEl.textContent = String(days).padStart(2, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minutesEl.textContent = String(minutes).padStart(2, '0');
        secondsEl.textContent = String(seconds).padStart(2, '0');
      }
      
      // Initial update
      updateCountdown();
      
      // Update every second
      setInterval(updateCountdown, 1000);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRyzeAnnouncementBar);
  } else {
    initRyzeAnnouncementBar();
  }
})();

